import React, { useEffect, useState } from "react";
import SpecialPricePage from "../../../../entities/DashboardPage/AccountingModule/SpecialPrice";
import AuthService from "../../../../api/AuthService";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../context/AlertContext";

const SpecialPrice = () => {
  const [loading, setLoading] = useState(false)
  const [itemList, setItemList] = useState()
  const {showAlert} = useAlert();

  useEffect(() => {
    getItem();
  },[])

  const getItem = async (text) => {
    setLoading(true);
    
    try {
      const result = await AuthService.getItemsList(text);
      if (result?.success) {
        setItemList(result?.data?.items);
        setLoading(false);
      } else {
    
        setLoading(false);
      }
    } catch (error) {
    
      setLoading(false);
    }
  };

  const handleAddSale = async (saleName,startDate,endDate,product) => {
    LoaderHelper.loaderStatus(true);
  
    setLoading(true)
    try {
      const result = await AuthService.handleSale(saleName,startDate,endDate,product);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
  
        showAlert(result?.message,"success");
        // navigate("/dashboard/invoice")
  
  
      } else {
          
        setLoading(false)
        LoaderHelper.loaderStatus(false);
  
        showAlert(result?.message,"error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
  
      showAlert(error,"error");
    }
  };


  return(
    
    <>
      <SpecialPricePage loading={loading} handleAddSale={handleAddSale} itemList={itemList} handleItemList={getItem}/>

    </>
  )
}

export default SpecialPrice